module.exports = __webpack_public_path__ + "static/media/youtube.59358dca.svg";